import { isMobile, isSafari, isSmartphone, isTouch } from '../_app/cuchillo/core/Basics';
import { C, GetBy } from '../_app/cuchillo/core/Element';
import { Interaction } from '../_app/cuchillo/core/Interaction';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { Sizes } from '../_app/cuchillo/core/Sizes';
import InterfaceCanvas from '../_app/cuchillo/layout/InterfaceCanvas';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import InfiniteScroll__Item from '../_app/cuchillo/scroll/InfiniteScroll__Item';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { CSS } from '../_app/cuchillo/utils/CSS';
import { Maths } from '../_app/cuchillo/utils/Maths';
import Home from '../pages/Home';
import gsap, { Power2 } from 'gsap';


export default class InfiniteScroll__HomeItem extends InfiniteScroll__Item {
    _limits;
    data;
    _card;
    _figure;
    _figureOffset = 0;
    _video;
    _src;
    _isPlay;
    _isShow;
    indice = 0;
    _scale = 1;

    _cropCache = null;
    _cropCacheIndice = -1;
    _cropCacheW = 0;
    _cropCacheH = 0;

    getMedia;

    _ctx = InterfaceCanvas.ctx;

    textPosition = { x: 0, y: 0 };
    textPosition2 = { x: 0, y: 0 };
    fields = {
        name:   { x: 0, y: 0 },
        title:  { x: 0, y: 0 },
        client: { x: 0, y: 0 },
    };
    offset = {
        grid:  Metrics.parseSize("10fpx") * Sizes.RATIO,
        grid2: Metrics.parseSize("40fpx") * Sizes.RATIO,
    };
    style = {
        size:       Metrics.FONT_SIZE_S * Sizes.RATIO,
        unit:       "px",
        fontFamily: 'EB Garamond',
        color:      "#ffffff",
        textAlign:  "left",
        padding: Metrics.parseSize("24fpx") * Sizes.RATIO,
    };

    _rectSize = 0;
    _cover = { sx: 0, sy: 0, sw: 0, sh: 0, size: 0, imgW: 0, imgH: 0, ready: false };
    _dest  = { x: 0, y: 0, size: 0 };

    _checkValues = Metrics.WIDTH > 500? 
        {
            min: -4,
            max: 5,
        } :
        {
            min: -3,
            max: 2,
        } 


    constructor(__d, __i, __axis = InfiniteScroll.AXIS_Y) {
        super(__d, __i, __axis, true);

        this.indice = this.index;
        this.line1   = GetBy.class("line", this.dom)[0];
        this.line2   = GetBy.class("line", this.dom)[1];
        this.counter = GetBy.class("counter-roman", this.dom)[0];

        this._card = GetBy.selector('[data-project-button]', this.dom)[0];
        this._card.setAttribute("data-index", this.indice);

        this.data = {
            id:       0,
            title:    GetBy.selector("[data-project-title]",    this._card)[0].dataset.projectTitle,
            director: GetBy.selector("[data-project-director]", this._card)[0].getAttribute("data-project-director"),
            client:   GetBy.selector("[data-project-client]",   this._card)[0].textContent,
            counter:   GetBy.selector("[data-project-counter]",   this._card)[0].textContent,
            href:     this._card.href,
        };
    }


    resize() {
        super.resize();
        this._rectSize = Math.max(Metrics.WIDTH * .3, Metrics.HEIGHT * .35) * Sizes.RATIO;
        if(this.style) this.style.size = Metrics.FONT_SIZE_S * Sizes.RATIO;
    }

    drawHook() {
        if (!this._card) return;
        this.move();
    }


    play() {
        if (this._isPlay) return;

        this._isPlay = true;
        this.callbackShow();
        gsap.killTweensOf(this.counter);
        gsap.to(this.counter, { opacity: 1, duration: .1, ease: Power2.easeIn });
    }

    pause() {
        if (!this._isPlay) return;
        this._isPlay = false;
        gsap.killTweensOf(this.counter);
        this.counter.style.opacity = .4;
    }

    move() {
        if (this.progress >= 0 && this.progress < 1) {
            this.play();
        } else {
            this.pause();
        }

        this.line1.style.setProperty('--progress', this.progress);

        this._drawSquare();
    }

    _drawSquare() {
        if (!this._ctx) return;

        const progressNorm = this.progress - 1;
        
        if(progressNorm < this._checkValues.min || progressNorm > this._checkValues.max) {
            const media = this.getMedia(this.indice);

            if (media?.isLoaded && !media?.video.paused) {
                media?.video.pause();
            }

            return;
        }

        let size = this._rectSize;
        const dist = progressNorm > 0 ? (1 + progressNorm) - 1 : -progressNorm;
        const destSize = size * Math.pow(0.5, dist);

        let destX, destY;

        if (progressNorm <= 0) {
            const stackOffset = size - destSize;
            destX = stackOffset * 2;
            destY = Metrics.HEIGHT_RATIO - destSize;
        } else {
            destX = 0;
            const stackOffset = size - destSize;
            destY = Metrics.HEIGHT_RATIO - size - stackOffset;
        }

        this._ctx.globalAlpha = Home.positionCircle.opacity ?? 1;

        const auxCalc = (p)=> {
            return Metrics.HEIGHT_RATIO - (size * Math.pow(0.5, -p));
        }

        let mod = {
            w: 0,
            h: 0,
            sw: 1,
            sh: 1
        };
    
        if(progressNorm >= 0 && progressNorm <= 1) {
            mod.h = -((destY + destSize) - auxCalc(progressNorm-1));

            mod.sh = mod.h/destSize;
        } else if(progressNorm >= -1 && progressNorm <= 0) {
            mod.w = destX;
            destX = 0;
            mod.sw = mod.w/destSize;
        }

        this.drawImage(Home.positionCircle.x + destX, Home.positionCircle.y + destY, destSize + mod.w, destSize + mod.h);
        this.checkHover(Home.positionCircle.x + destX, Home.positionCircle.y + destY, destSize + mod.w, destSize + mod.h);
        this._ctx.globalAlpha = 1;
}

    checkHover(x,y,w,h) {
        let xM = Interaction.positions.mouse.x * Sizes.RATIO;
        let yM = Interaction.positions.mouse.y * Sizes.RATIO;

        if(
            xM >= x &&
            xM <= x + w &&
            yM >= y &&
            yM <= y + h
        ) {
            this.setHover();
        }
    }

    _computeCrop(imgW, imgH, w, h) {
        const scale = Math.max(w / imgW, h / imgH);
        const srcW  = w / scale;
        const srcH  = h / scale;
        return {
            srcX: (imgW - srcW) / 2,
            srcY: (imgH - srcH) / 2,
            srcW,
            srcH
        };
    }

    drawImage(x, y, w, h) {
        const item = this.getMedia(this.indice);

        if(!item) return;

        let img, imgW, imgH;
    
        if(item.isLoaded && !isSmartphone && !isSafari) {
            img  = item.video;
            imgW = img.videoWidth;
            imgH = img.videoHeight;

            if(img.paused && Home.absSpeed<100) img.play();
        } else {
            img  = item.img;
            imgW = img.naturalWidth;
            imgH = img.naturalHeight;
        }

        // Recalcular crop solo si cambió el indice o el tamaño del box
        if (
            this._cropCacheIndice !== this.indice ||
            this._cropCacheW     !== w ||
            this._cropCacheH     !== h
        ) {
            this._cropCache      = this._computeCrop(imgW, imgH, w, h);
            this._cropCacheIndice = this.indice;
            this._cropCacheW      = w;
            this._cropCacheH      = h;
        }

        const { srcX, srcY, srcW, srcH } = this._cropCache;

        // Enteros en todas las coordenadas → evita antialiasing subpixel (~2x más rápido)
        this._ctx.drawImage(
            img,
            srcX | 0, srcY | 0, srcW | 0, srcH | 0,
            x    | 0, y    | 0, w    | 0, h    | 0
        );

         // ── Label "CLIENTE" ──────────────────────────────────────────
        const label     = this.data.counter + "         " + this.data.client;          // o "CLIENTE" literal
        const fontSize  = this.style.size;
        const padding   = 50;

        this._ctx.save();
        this._ctx.font         = `${fontSize}px ${this.style.fontFamily}`;
        this._ctx.fillStyle    = this.style.color;
        this._ctx.textAlign    = "left";
        this._ctx.textBaseline = "top";
        this._ctx.fillText(label, (x + w + this.style.padding) | 0, (y) | 0);
        this._ctx.restore();
    }

    dispose() {
        super.dispose();
    }
}
